import {format as dateFnsFormat} from "date-fns";
import {de} from "date-fns/locale";

export function formatDate(date: Date | number | null | undefined, format = "dd.MM.yyyy - HH:mm"): string {
    return date ? dateFnsFormat(date, format, {locale: de}) : "";
}